/* ⚛ REACT */
import { useRef } from "react";

/* 📦 LIBS */
import { useNavigate, useParams } from "react-router";
import { toast } from 'react-toastify';
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Label, InputPassword, Button } from "../../Components/index.js";

/* 🔗 SERVICE */
import { authService } from "../../Services/authServices/requests.ts";

/* 🎨 STYLES */
import { Container, Title, ContainerForm } from "./styles";

/* 🔧 UTILS */
import { isValidPassword, isValidPassword2 } from "../../util/validate.js";

const ResetPassword = () => {
    const { t } = useTranslation();

    document.title = t("reset-password.document-title");
    const { token } = useParams();
    const navigate = useNavigate();

    const passwordField = useRef();
    const confirmpasswordField = useRef();

    const passwordValue = useRef();
    const confirmpasswordValue = useRef();

    async function sendNewPassword(){
        if(isValidPassword(passwordValue.current) && isValidPassword2(confirmpasswordValue.current, passwordValue.current)){
            try {
                const response = await authService.ForgetPassWrodSubmit(token, passwordValue.current, confirmpasswordValue.current)
                toast(response.message, {
                    position: "top-center",
                    type: 'success',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                navigate('/')
            } catch (error) {
                toast(error.message, {
                    position: "top-center",
                    type: 'error',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
            }
        }else{
            toast(t("message.reset-password.send-new-password"), {
                position: "top-center",
                type: 'error',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }
    

    return (
        <Container>
            <ContainerForm>
                <Title> {t("reset-password.title")} </Title>
                <Label text={t("inputs.new-password.label")} aling="flex-start"/>
                    <InputPassword 
                        id='password' 
                        name='password' 
                        placeholder= {t("inputs.new-password.placeholder")}
                        innerRef={passwordField}
                        invalidMessage = {t("inputs.new-password.invalid-message")}
                        validationFunction = {(text) => isValidPassword(text)}
                        onchange={(text) => passwordValue.current = text}>
                    </InputPassword>


                <Label text={t("inputs.confirm-password.label")} aling="flex-start"/>
                <InputPassword 
                    id='newpasswordconfirm' 
                    name='newpasswordconfirm' 
                    placeholder= {t("inputs.confirm-password.label")}
                    innerRef={confirmpasswordField}
                    invalidMessage = {t("inputs.confirm-password.label")}
                    validationFunction = {(text) => isValidPassword2(text, passwordValue.current)}
                    onchange={(text) => confirmpasswordValue.current = text}>
                </InputPassword>

                <Button text={t("buttons.reset")} width={'120px'} onClick={()=> sendNewPassword()}/>
            </ContainerForm>
        </Container>
    );
}

export default ResetPassword;
